.form {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
}

.buttons {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
